export default "__VITE_ASSET__Cj6cU3LS__"